module.exports = __webpack_public_path__ + "footer-icon-facebook.3260d109d7fe2978ee75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/footer-icon-facebook.svg
// module id = 1014
// module chunks = 2